module.exports = __webpack_public_path__ + "images/category_lp/common/medal@2x_b3796e23fd8ac1005387fa64547decf7.png";